import React, { useEffect } from "react";
import styled  from "styled-components";
import { useNavigate } from "react-router";


const NavBar = styled.div`
    font-family: 'Montserrat', sans-serif;
    position: absolute;
    background: rgba(17,19,20,0.6);
    width: 100%;
    height: 50px;
    color: white;
    z-index: 1;


    h1{
      transform: translateY(10%);
      -webkit-transform: translateY();
      margin:0;
      text-align: center;
      opacity: 1;
      color: #ff770f;
    }

    h1:hover{
      opacity: 1;
    color: white;
  }
    `


function Navbar() {

  useEffect(()=>{
   
  })
  let home = useNavigate(); // navigate react function

  function doehet(){
    console.log("doe het")
  }

  return (
    <NavBar onClick={doehet}>
      <h1 >FOX CONNECT</h1>
    </NavBar>
  );
}
export default Navbar;